import { useHasPermission } from '@contexts/permissions-provider/hooks/use-has-permission/useHasPermission';
import * as React from 'react';

import type { CreditMemosTableProps } from '../credit-memos-table/CreditMemosTable.types';

import { CreditMemoCardMobile } from './credit-memo-card-mobile/CreditMemoCardMobile';
import styles from './CreditMemosTableMobile.module.css';

const CreditMemosTableMobile = React.memo(
  ({ creditMemos }: Readonly<CreditMemosTableProps>): React.ReactElement => {
    const canDownload = useHasPermission('Invoices_Open_Org');
    const sorted = React.useMemo(
      () =>
        [...creditMemos].sort(
          (a, b) =>
            new Date(b.appliedOn || 0).getTime() -
            new Date(a.appliedOn || 0).getTime()
        ),
      [creditMemos]
    );

    return (
      <div
        className={styles.mobileList}
        data-testid="invoice-credits-table-mobile"
      >
        {sorted.map((credit, index) => (
          <CreditMemoCardMobile
            key={credit.creditMemoNumber ?? credit.id ?? index}
            credit={credit}
            canDownload={canDownload}
          />
        ))}
      </div>
    );
  }
);

CreditMemosTableMobile.displayName = 'CreditMemosTableMobile';
export { CreditMemosTableMobile };
